import React from "react";
import Layout from "../components/_App/layout";
import SEO from "../components/_App/seo";
import Navbar from "../components/_App/Navbar";
import Footer from "../components/_App/Footer";
import PawiOzellikler from "../components/Features/PawiOzellikler";
import PawiOzellikler2 from "../components/Features/PawiOzellikler2";
import Shape1 from "../assets/images/shape1.png";
import Shape2 from "../assets/images/shape2.svg";
import Shape3 from "../assets/images/shape3.svg";
import Shape4 from "../assets/images/shape4.svg";
import Shape5 from "../assets/images/shape5.png";

const PawiPage = () => (
    <Layout>
        <SEO title="Pawi Net Veteriner Yazılımı" />

        <Navbar />

        <div className="page-title-area">
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <h2>Pawi Net Veteriner Yazılımı</h2>
                        <h5>Veteriner kliniğinizin dijital asistanı</h5>
                        <a
                            href="https://pawinet.com/"
                            className="btn btn-demo"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Giriş İçin Tıklayınız
                        </a>
                    </div>
                </div>
            </div>

            {/* Shape Images */}
            <div className="shape1">
                <img src={Shape1} alt="shape" />
            </div>
            <div className="shape2 rotateme">
                <img src={Shape2} alt="shape" />
            </div>
            <div className="shape3">
                <img src={Shape3} alt="shape" />
            </div>
            <div className="shape4">
                <img src={Shape4} alt="shape" />
            </div>
            <div className="shape5">
                <img src={Shape5} alt="shape" />
            </div>
            <div className="shape6 rotateme">
                <img src={Shape4} alt="shape" />
            </div>
            <div className="shape7">
                <img src={Shape4} alt="shape" />
            </div>
            <div className="shape8 rotateme">
                <img src={Shape2} alt="shape" />
            </div>
        </div>

        <PawiOzellikler />

        <PawiOzellikler2 />

        <Footer />
    </Layout>
)

export default PawiPage;
